import React from "react";

const Vileplume = ({ ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-1.8 -0.3 349.7 304.55"
      {...rest}
    >
      <g>
        <path
          fill="#0d131a"
          d="M265.6 187.9 Q264.2 203.85 253.05 211.25 246.25 215.8 231.35 218.65 L220.55 204.0 227.85 202.85 Q231.8 202.1 234.35 200.5 241.0 196.3 244.65 182.05 246.1 176.4 249.8 174.55 253.1 172.9 257.1 174.55 260.9 176.1 263.35 179.75 266.0 183.65 265.6 187.9"
        />
        <path
          fill="#5892bf"
          d="M262.5 189.35 Q260.15 205.85 245.55 212.35 240.65 214.55 233.45 215.95 L223.3 217.75 223.3 206.65 Q233.2 204.55 237.85 200.85 243.7 196.15 246.55 185.65 248.2 179.65 251.2 177.7 L256.8 177.55 Q259.5 178.95 261.2 182.35 263.0 185.85 262.5 189.35"
        />
        <path
          fill="#0d131a"
          d="M64.0 192.45 Q64.8 187.85 68.0 184.95 71.3 181.85 75.5 182.25 80.3 182.75 84.65 187.7 97.7 202.55 103.55 200.45 105.2 199.9 108.1 198.1 110.95 196.95 114.65 198.95 L112.9 214.6 Q103.2 221.55 87.3 217.05 71.6 212.6 65.55 201.65 63.15 197.35 64.0 192.45"
        />
        <path
          fill="#5892bf"
          d="M67.2 194.3 Q67.25 190.35 69.45 187.75 71.7 185.0 75.0 185.25 78.75 185.55 82.65 189.75 94.85 202.95 100.25 203.2 L103.95 202.35 Q106.1 201.75 108.2 202.65 L108.1 213.95 Q100.25 218.65 87.6 214.45 75.35 210.4 69.6 202.1 67.15 198.55 67.2 194.3"
        />
        <path
          fill="#0d131a"
          d="M251.75 231.25 Q263.45 226.85 270.35 229.6 277.0 232.25 274.15 239.2 272.5 243.15 256.9 252.3 238.7 263.0 218.2 269.65 213.8 271.1 211.3 268.3 208.1 264.65 205.3 252.05 204.3 247.65 199.45 242.9 196.8 240.25 190.25 235.35 184.65 231.2 183.25 229.35 181.1 226.5 184.15 224.65 195.05 218.0 207.5 231.25 212.15 236.15 215.55 242.4 218.7 248.1 219.0 251.25 219.15 252.9 222.35 250.9 L230.35 245.05 Q244.7 233.9 251.75 231.25"
        />
        <path
          fill="#5892bf"
          d="M253.9 233.35 Q268.3 228.65 271.45 233.25 272.6 235.0 271.75 237.5 270.9 239.85 268.95 241.4 260.95 247.8 240.85 257.65 220.5 267.6 214.8 267.7 212.65 267.75 211.15 263.45 L206.5 247.15 Q205.45 243.45 203.35 239.45 L200.5 234.1 Q199.35 231.7 199.8 230.55 200.35 229.15 203.35 228.4 206.05 227.7 211.6 240.15 L217.65 254.6 Q218.6 256.2 231.4 246.9 246.85 235.65 253.9 233.35"
        />
        <path
          fill="#46799e"
          d="M206.5 247.15 Q205.45 243.45 203.35 239.45 L200.5 234.1 Q199.35 231.7 199.8 230.55 200.35 229.15 203.35 228.4 205.8 227.75 210.6 238.05 213.2 243.6 216.95 253.0 L217.65 254.6 Q216.1 253.4 213.65 254.1 211.2 254.75 209.25 256.95 L206.5 247.15"
        />
        <path
          fill="#0d131a"
          d="M145.75 240.0 Q154.45 257.45 159.5 261.45 169.05 269.0 167.35 275.2 166.3 278.85 161.7 281.45 140.95 293.35 123.55 298.35 102.9 304.25 99.75 295.85 97.05 288.7 106.5 282.45 117.9 274.9 144.2 271.3 147.3 270.6 147.65 269.5 148.0 268.45 146.0 265.75 138.9 256.35 136.8 251.0 132.85 241.15 137.0 232.15 138.5 228.95 140.8 231.5 142.45 233.3 145.75 240.0"
        />
        <path
          fill="#5892bf"
          d="M142.8 241.8 Q150.25 255.25 154.0 259.4 L160.9 266.2 Q165.05 269.9 164.85 273.3 164.7 276.9 159.8 279.65 143.4 288.9 126.2 294.5 104.9 301.4 102.05 294.75 99.15 288.0 114.0 281.65 125.6 276.7 146.4 272.55 150.8 271.45 150.85 269.45 150.9 268.35 148.85 265.35 L145.55 260.9 Q143.45 258.0 142.15 255.5 138.3 248.15 138.05 237.7 138.0 234.75 139.3 236.15 140.2 237.15 142.8 241.8"
        />
        <path
          fill="#46799e"
          d="M142.8 241.8 Q150.25 255.25 154.0 259.4 L157.7 263.2 Q155.75 261.9 152.45 261.25 148.1 260.35 146.75 262.5 142.8 257.2 141.15 253.35 138.3 246.75 138.05 237.7 138.0 234.75 139.3 236.15 140.2 237.15 142.8 241.8"
        />
        <path
          fill="#0d131a"
          d="M200.9 147.75 Q219.7 155.0 223.9 168.4 230.45 189.25 233.1 201.05 237.5 220.65 235.25 229.3 231.2 244.95 215.65 251.3 201.85 256.9 169.8 258.25 142.95 259.4 126.3 254.35 110.2 249.5 105.8 239.6 100.9 228.5 101.6 217.4 102.1 209.7 106.05 198.1 111.0 183.5 112.0 178.9 114.45 167.5 112.35 156.95 111.0 150.1 126.5 145.45 141.5 140.95 162.2 141.25 184.75 141.6 200.9 147.75"
        />
        <path
          fill="#5892bf"
          d="M227.2 189.05 Q230.25 200.45 231.45 207.0 235.05 226.55 229.2 236.8 224.45 245.05 210.95 249.75 195.5 255.15 169.55 255.5 139.15 255.9 125.85 251.6 112.6 247.25 107.8 235.5 104.1 226.4 105.0 216.35 105.6 209.5 109.1 198.35 113.25 185.1 114.2 180.35 116.25 169.95 114.4 161.05 113.05 154.75 128.55 150.1 143.5 145.65 163.9 145.65 186.1 145.6 201.5 151.15 219.5 157.7 222.4 170.3 L227.2 189.05"
        />
        <path
          fill="#46799e"
          d="M104.95 223.45 Q108.95 233.75 128.15 239.2 145.5 244.1 169.05 243.6 192.3 243.15 209.9 237.7 229.0 231.85 232.85 222.5 232.6 230.85 229.2 236.8 224.45 245.05 210.95 249.75 195.5 255.15 169.55 255.5 139.15 255.9 125.85 251.6 112.6 247.25 107.8 235.5 105.35 229.5 104.95 223.45"
        />
        <path
          fill="#46799e"
          d="M226.15 184.75 Q200.95 188.45 166.2 186.95 129.85 185.4 114.3 179.15 116.15 169.5 114.4 161.05 113.05 154.75 128.55 150.1 143.5 145.65 163.9 145.65 186.1 145.6 201.5 151.15 219.5 157.7 222.4 170.3 L226.15 184.75"
        />
        <path
          fill="#0d131a"
          d="M138.5 196.7 Q136.45 196.75 134.95 195.3 133.45 193.85 133.45 191.8 133.4 189.75 134.85 188.25 136.3 186.8 138.35 186.75 140.4 186.7 141.9 188.15 143.35 189.6 143.4 191.65 143.4 193.7 142.0 195.2 140.55 196.65 138.5 196.7"
        />
        <path
          fill="#e9545d"
          d="M138.45 194.75 Q137.2 194.75 136.3 193.9 135.4 193.0 135.4 191.75 135.35 190.5 136.25 189.65 137.1 188.75 138.35 188.7 139.65 188.7 140.5 189.55 141.4 190.45 141.4 191.7 141.45 192.95 140.55 193.85 139.7 194.7 138.45 194.75"
        />
        <path
          fill="#0d131a"
          d="M173.5 200.1 Q173.85 200.45 173.65 201.6 173.15 204.2 172.0 206.3 170.4 209.15 168.2 209.2 165.95 209.25 164.2 206.35 163.0 204.25 162.45 201.65 162.3 200.8 162.55 200.4 162.9 199.9 164.0 199.9 L171.7 199.8 Q173.1 199.75 173.5 200.1"
        />
        <path
          fill="#ed8599"
          d="M164.75 201.75 L171.45 201.65 170.65 204.5 Q169.6 207.3 168.2 207.35 166.8 207.35 165.65 204.55 L164.75 201.75"
        />
        <path
          fill="#0d131a"
          d="M320.3 70.85 Q324.5 85.75 318.65 95.85 316.5 99.65 311.05 103.3 304.6 107.65 295.7 110.25 272.45 117.05 241.15 109.85 223.5 105.8 208.0 99.45 192.55 93.05 188.05 88.0 170.95 94.95 150.65 96.95 147.1 107.2 146.3 114.05 143.75 134.55 136.5 145.0 130.3 153.8 122.5 153.4 98.3 152.05 74.9 145.0 52.2 138.15 34.55 127.25 16.65 116.15 7.7 103.15 -1.8 89.45 0.4 75.85 2.85 60.85 19.75 49.7 36.5 38.7 62.4 34.6 75.4 17.65 97.35 8.6 117.35 0.4 141.25 0.05 163.95 -0.3 184.0 6.4 204.35 13.2 215.65 25.15 243.95 18.0 267.85 23.9 288.55 29.05 303.05 43.0 316.0 55.45 320.3 70.85"
        />
        <path
          fill="#e9545d"
          d="M82.0 36.7 Q103.5 37.05 123.7 44.3 179.05 64.2 173.9 106.15 171.4 126.45 158.45 136.7 143.25 148.75 112.55 148.0 92.6 147.55 71.75 140.75 52.0 134.35 35.75 123.8 19.5 113.2 10.95 101.2 1.95 88.55 3.8 77.2 5.65 65.95 16.75 56.45 27.65 47.1 44.6 41.85 62.2 36.35 82.0 36.7"
        />
        <path
          fill="#c94850"
          d="M3.8 77.2 Q4.05 75.55 4.45 74.25 7.8 87.3 24.9 99.85 40.65 111.35 65.05 120.35 88.55 129.05 113.8 133.05 139.75 137.2 160.25 135.2 145.15 148.75 112.55 148.0 92.6 147.55 71.75 140.75 52.0 134.35 35.75 123.8 19.5 113.2 10.95 101.2 1.95 88.55 3.8 77.2"
        />
        <path
          fill="#e9545d"
          d="M201.2 33.0 Q194.05 37.95 191.5 42.45 188.2 41.5 182.05 40.7 L172.1 39.5 Q158.8 37.85 149.45 39.5 141.2 40.95 132.95 45.6 118.75 38.75 100.5 35.65 82.7 32.65 66.65 34.1 75.65 21.65 95.2 13.1 115.55 4.2 139.1 3.25 162.05 2.35 182.8 9.1 202.7 15.55 213.4 26.6 207.75 28.5 201.2 33.0"
        />
        <path
          fill="#e9545d"
          d="M310.3 55.85 Q320.5 70.7 318.65 84.2 299.55 70.75 268.35 66.9 255.55 65.3 241.2 66.85 228.5 68.15 219.5 71.25 L219.75 68.25 Q221.6 53.2 193.95 43.45 205.2 27.65 232.85 24.85 258.35 22.25 279.9 31.45 299.3 39.75 310.3 55.85"
        />
        <path
          fill="#0d131a"
          d="M175.5 36.4 Q183.85 37.4 192.2 39.8 L197.05 41.35 Q210.4 46.1 217.5 53.35 224.6 60.6 223.6 68.45 222.95 73.7 223.4 88.4 222.75 101.65 216.5 107.05 210.55 112.1 199.9 110.8 L159.4 106.15 Q128.4 102.15 122.75 98.65 116.95 95.05 117.3 81.85 117.45 76.85 120.45 55.7 121.65 47.25 129.7 42.65 137.6 38.15 149.55 36.45 161.8 34.7 175.5 36.4"
        />
        <path
          fill="#f2984f"
          d="M221.2 68.9 Q221.05 70.25 220.65 81.25 220.3 90.15 218.95 95.35 214.8 111.55 197.65 109.45 L160.15 105.15 Q131.4 101.4 126.2 98.2 120.55 94.7 120.95 78.0 121.1 72.5 123.05 56.85 124.3 46.95 139.5 41.7 154.7 36.5 175.05 38.95 195.4 41.45 208.9 50.25 222.4 59.0 221.2 68.9"
        />
        <path
          fill="#0d131a"
          d="M173.95 71.35 Q155.7 69.1 146.0 65.45 134.35 61.1 133.45 54.3 132.5 47.0 145.65 43.05 158.5 39.2 175.2 41.25 191.75 43.3 203.0 50.05 214.4 56.9 212.5 64.05 210.85 70.25 200.55 71.95 191.25 73.45 173.95 71.35"
        />
        <path
          fill="#c18963"
          d="M174.0 69.2 Q157.05 67.1 147.95 64.3 137.0 60.9 136.0 56.05 134.9 50.85 147.0 48.4 158.8 46.05 174.3 47.95 189.75 49.85 200.35 54.95 211.1 60.1 209.55 65.1 208.2 69.45 198.7 70.35 190.1 71.2 174.0 69.2"
        />
        <path
          fill="#0d131a"
          d="M344.5 116.9 Q347.9 133.1 339.2 146.75 328.75 163.2 304.8 165.85 288.15 167.7 270.8 165.1 253.0 162.45 239.95 155.95 205.55 138.75 195.65 126.85 189.95 120.0 189.2 112.4 188.45 104.95 192.35 95.4 198.55 80.5 215.55 71.55 237.05 60.25 268.7 64.15 302.5 68.3 322.05 82.65 340.2 96.0 344.5 116.9"
        />
        <path
          fill="#e9545d"
          d="M340.7 115.9 Q343.9 130.9 335.9 144.2 326.2 160.35 304.1 162.65 286.05 164.55 271.2 162.8 276.15 153.95 273.5 139.1 272.7 134.45 269.35 128.65 265.8 122.55 260.1 116.25 253.35 108.8 244.7 102.35 235.05 95.2 223.95 89.85 215.0 85.55 204.8 82.4 212.5 74.25 225.05 70.0 243.25 63.8 268.35 66.9 299.55 70.75 318.65 84.2 327.65 90.6 333.25 98.7 338.75 106.7 340.7 115.9"
        />
        <path
          fill="#c94850"
          d="M341.25 128.2 Q339.8 141.1 331.5 150.1 321.55 160.8 304.1 162.65 286.05 164.55 271.2 162.8 275.15 155.75 274.3 145.05 299.85 148.95 318.2 144.05 335.85 139.4 341.25 128.2"
        />
        <path
          fill="#0d131a"
          d="M277.9 141.1 Q283.65 173.6 244.5 181.85 218.45 187.3 164.9 182.05 108.95 176.55 79.85 160.05 44.15 139.85 63.6 109.05 75.8 89.75 102.65 80.75 132.6 70.7 177.85 74.75 220.5 78.6 250.4 102.7 262.2 112.2 269.75 123.25 276.5 133.1 277.9 141.1"
        />
        <path
          fill="#e9545d"
          d="M177.55 77.15 Q191.5 78.45 204.8 82.4 233.2 90.95 253.7 109.85 262.15 117.6 267.5 125.7 272.5 133.25 273.5 139.1 276.15 153.95 271.2 162.8 267.45 169.6 258.8 173.7 252.65 176.6 240.8 179.3 218.4 184.4 171.35 179.2 126.65 174.25 98.0 164.75 74.95 157.1 65.65 143.25 54.65 126.8 68.95 107.6 81.75 90.45 107.25 82.4 135.95 73.4 177.55 77.15"
        />
        <path
          fill="#f9dbe1"
          d="M119.0 123.85 Q119.0 128.45 112.75 130.7 106.45 132.95 98.65 131.1 90.1 129.05 86.55 126.8 82.4 124.15 82.4 119.8 82.4 114.9 87.9 111.45 93.85 107.75 102.05 108.7 110.75 109.75 115.25 114.55 119.0 118.55 119.0 123.85"
        />
        <path
          fill="#f9dbe1"
          d="M33.7 74.15 Q33.7 76.55 30.2 79.25 26.6 82.05 23.9 81.3 17.75 79.6 16.3 78.7 13.4 76.85 14.05 72.8 14.6 69.75 18.55 67.2 22.55 64.6 25.6 65.35 28.25 66.05 31.05 69.25 33.7 72.25 33.7 74.15"
        />
        <path
          fill="#f9dbe1"
          d="M195.35 86.05 Q194.85 88.4 190.4 88.95 L182.1 88.4 174.55 86.7 Q170.95 85.6 170.95 83.65 170.95 81.45 173.9 80.5 L181.15 80.2 Q186.95 80.9 190.8 82.25 195.75 83.9 195.35 86.05"
        />
        <path
          fill="#f9dbe1"
          d="M186.95 13.85 Q186.5 16.25 181.45 17.15 176.75 18.0 172.5 17.0 167.75 15.85 164.55 14.3 160.55 12.35 160.55 10.25 160.55 8.05 163.5 7.1 L170.75 6.8 Q176.2 7.4 181.45 9.45 187.4 11.7 186.95 13.85"
        />
        <path
          fill="#f9dbe1"
          d="M99.25 41.45 Q99.25 43.1 96.3 44.15 93.7 45.05 90.6 44.95 L85.25 44.9 Q82.65 44.65 82.35 43.35 82.0 41.85 83.9 40.8 85.65 39.8 88.75 39.55 92.75 39.2 95.6 39.55 99.2 39.95 99.25 41.45"
        />
        <path
          fill="#f9dbe1"
          d="M220.85 133.75 Q221.85 136.9 218.0 139.8 214.1 142.7 208.35 143.05 L199.1 142.7 Q195.65 141.75 194.7 138.75 193.65 135.4 196.75 131.85 200.05 128.0 205.9 126.95 212.1 125.8 216.25 128.15 219.65 130.1 220.85 133.75"
        />
        <path
          fill="#f9dbe1"
          d="M249.75 36.2 Q250.75 39.35 246.9 42.25 243.0 45.15 237.25 45.5 L228.0 45.1 Q224.55 44.2 223.65 41.2 222.6 37.8 225.65 34.25 228.95 30.4 234.85 29.35 241.05 28.2 245.15 30.55 248.65 32.55 249.75 36.2"
        />
        <path
          fill="#f9dbe1"
          d="M235.8 102.3 Q240.35 102.7 243.35 104.65 246.35 106.6 247.15 109.15 247.8 111.3 246.9 113.25 246.05 114.95 243.35 114.65 240.65 114.35 238.15 112.25 L232.55 107.7 Q229.65 104.95 230.35 103.55 231.15 101.9 235.8 102.3"
        />
        <path
          fill="#f9dbe1"
          d="M305.55 127.45 Q305.55 131.0 300.95 132.6 296.85 134.0 290.65 133.35 284.6 132.7 282.0 130.1 279.8 127.9 279.8 123.85 279.8 119.0 280.75 117.4 282.45 114.5 287.95 115.25 295.05 116.25 300.45 120.25 305.55 123.95 305.55 127.45"
        />
        <path
          fill="#f9dbe1"
          d="M67.5 80.75 Q69.75 83.5 67.15 87.55 64.85 91.25 59.6 94.65 54.5 97.95 50.85 97.6 47.8 97.25 45.2 94.1 42.15 90.35 41.9 88.45 41.4 85.2 46.15 82.3 52.3 78.6 59.0 78.3 65.3 78.0 67.5 80.75"
        />
        <path
          fill="#f9dbe1"
          d="M315.3 89.25 Q315.55 92.55 312.3 92.5 310.6 92.45 304.75 90.8 300.9 89.7 299.1 88.55 295.95 86.55 296.05 83.3 296.15 80.3 299.55 79.35 302.65 78.45 305.45 79.7 310.35 81.8 312.55 83.8 315.05 86.1 315.3 89.25"
        />
        <path
          fill="#f9dbe1"
          d="M99.55 57.7 Q99.55 58.95 97.8 60.5 95.9 62.2 93.9 62.2 91.85 62.2 90.1 60.75 88.5 59.4 88.5 58.15 88.5 57.0 90.05 56.2 91.6 55.4 93.75 55.4 L97.75 56.0 Q99.55 56.65 99.55 57.7"
        />
        <path
          fill="#f9dbe1"
          d="M280.75 92.0 Q283.1 92.0 284.75 92.55 286.6 93.2 286.6 94.25 286.6 95.5 284.85 97.1 282.95 98.8 280.95 98.8 278.9 98.8 277.15 97.3 275.5 95.95 275.5 94.7 275.5 93.6 277.05 92.8 278.55 92.0 280.75 92.0"
        />
        <path
          fill="#f9dbe1"
          d="M271.2 48.2 Q271.2 49.45 269.45 51.0 267.55 52.7 265.55 52.7 263.5 52.7 261.75 51.25 260.15 49.9 260.15 48.65 260.15 47.55 261.7 46.75 263.2 45.95 265.4 45.95 267.75 45.95 269.4 46.5 271.2 47.15 271.2 48.2"
        />
        <path
          fill="#f9dbe1"
          d="M138.05 82.75 Q138.05 83.9 136.5 84.65 135.0 85.45 132.8 85.45 L127.65 85.45 Q124.65 85.3 124.65 84.35 124.65 83.2 127.65 81.65 130.65 80.05 132.8 80.05 135.0 80.05 136.5 80.85 138.05 81.65 138.05 82.75"
        />
        <path
          fill="#f9dbe1"
          d="M297.15 48.0 Q294.9 49.95 290.45 48.85 286.65 47.85 284.75 45.95 L280.55 41.6 Q278.15 38.25 279.35 35.3 280.4 32.8 286.75 35.7 292.2 38.2 294.5 40.5 296.05 42.05 297.0 44.65 297.95 47.25 297.15 48.0"
        />
        <path
          fill="#f9dbe1"
          d="M94.8 23.55 Q94.8 24.6 92.1 25.5 89.6 26.3 87.2 26.3 L82.0 26.3 Q79.0 26.1 79.0 25.15 79.0 23.95 82.3 21.45 85.75 18.85 87.8 18.85 89.85 18.85 92.4 20.65 94.8 22.4 94.8 23.55"
        />
        <path
          fill="#f9dbe1"
          d="M160.9 116.65 Q160.65 119.0 157.3 120.05 L151.75 120.7 Q145.5 120.7 144.95 116.65 144.35 112.15 147.75 109.9 150.45 108.05 153.55 108.5 157.05 109.0 159.25 112.3 161.0 114.9 160.9 116.65"
        />
        <path
          fill="#f9dbe1"
          d="M156.15 29.0 Q156.15 30.55 154.5 31.6 152.9 32.7 150.6 32.7 148.3 32.7 146.7 31.6 145.05 30.55 145.05 29.0 145.05 27.45 146.7 26.35 148.3 25.25 150.6 25.25 152.9 25.25 154.5 26.35 156.15 27.45 156.15 29.0"
        />
        <path
          fill="#f9dbe1"
          d="M188.2 26.75 Q188.2 28.35 186.15 30.05 184.0 31.8 181.75 31.8 179.5 31.8 176.75 29.8 174.0 27.85 174.0 26.3 174.0 24.75 175.6 23.65 177.2 22.55 179.5 22.55 182.0 22.55 185.0 23.9 188.2 25.3 188.2 26.75"
        />
        <path
          fill="#f9dbe1"
          d="M70.7 48.05 Q70.7 50.8 69.1 52.05 67.35 53.4 61.15 55.2 56.4 56.55 50.1 56.4 42.6 56.15 40.85 53.4 38.8 50.2 43.7 46.95 47.2 44.6 50.3 43.9 62.05 41.2 67.1 43.15 70.7 44.5 70.7 48.05"
        />
        <path
          fill="#f9dbe1"
          d="M132.1 12.5 Q132.1 14.5 128.95 15.95 125.7 17.45 121.25 17.45 L112.25 17.3 Q107.7 16.9 107.7 15.2 107.7 13.1 110.9 10.8 114.3 8.35 118.55 8.0 124.3 7.5 128.35 9.0 132.1 10.4 132.1 12.5"
        />
        <path
          fill="#f9dbe1"
          d="M270.75 82.75 Q268.85 85.3 266.35 85.4 264.3 85.45 259.9 83.65 L251.35 79.95 Q247.25 77.6 247.25 74.6 247.25 71.55 252.05 70.65 L261.75 70.1 Q266.45 70.1 269.7 75.05 272.95 79.85 270.75 82.75"
        />
        <path
          fill="#46799e"
          d="M267.0 242.55 Q260.6 248.3 239.7 258.15 219.85 267.5 217.75 266.9 215.4 266.2 224.6 260.7 L239.7 252.05 Q249.2 246.3 260.35 242.45 271.4 238.65 267.0 242.55"
        />
        <path
          fill="#0d131a"
          d="M195.75 196.2 Q193.7 196.25 192.25 194.8 190.75 193.35 190.75 191.3 190.7 189.25 192.15 187.75 193.6 186.3 195.65 186.25 197.7 186.2 199.15 187.65 200.65 189.1 200.65 191.15 200.7 193.2 199.25 194.7 197.8 196.15 195.75 196.2"
        />
        <path
          fill="#e9545d"
          d="M195.75 194.25 Q194.5 194.25 193.6 193.4 192.7 192.5 192.7 191.25 192.65 190.0 193.55 189.15 194.4 188.25 195.65 188.2 196.9 188.2 197.8 189.05 198.7 189.95 198.7 191.2 198.75 192.45 197.85 193.35 197.0 194.2 195.75 194.25"
        />
        <path
          fill="#c94850"
          d="M196.25 168.15 Q215.45 168.8 237.0 165.3 264.3 160.85 274.3 152.0 273.8 158.15 271.2 162.8 267.45 169.6 258.8 173.7 252.65 176.6 240.8 179.3 218.4 184.4 171.35 179.2 126.65 174.25 98.0 164.75 86.65 161.0 78.1 155.25 100.5 161.8 145.95 165.4 L196.25 168.15"
        />
      </g>
    </svg>
  );
};

export default Vileplume;
